export function getUserInitials(firstName, lastName) {
    var _a, _b;
    return [(_a = firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0)) !== null && _a !== void 0 ? _a : '', (_b = lastName === null || lastName === void 0 ? void 0 : lastName.charAt(0)) !== null && _b !== void 0 ? _b : ''];
}
